export default {
  selectAllBtn: 'select-all-button',
  deleteBtn: 'delete-button',
  resetBtn: 'reset-button',
};
